import React, { useState, useEffect } from "react";
import authManager from "../../modules/authManager.js";
import { Spin } from 'antd'
import "./Login.css"
// import './Auth.css'
// import G2GLogo from '../../images/g2g-logo.png'

const Login = ({ routerProps }) => {
  const [loggedIn, setIsLoggedIn] = useState(false);
  const [buttonClicked, changeButtonClicked] = useState(false);
  const [credentials, setCredentials] = useState({
    email: "",
    password: "",
  });

  const emailArray = [
    'blagg32@gmail.com',
    'jeremy@gear2go.us',
    'steven.lee@gear2go.us',
    'gavin.mcgarry@gear2go.us',
    'rdbishop06+prod01@gmail.com',
    'chasef7031@gmail.com'
  ]

  const handleFieldChange = (evt) => {
    const stateToChange = { ...credentials };
    stateToChange[evt.target.id] = evt.target.value;
    setCredentials(stateToChange);
  };
  const handleLogin = (e) => {
    e.preventDefault();
    const customerCreds = {
      email: credentials.email.toLowerCase(),
      password: credentials.password,
    };
    changeButtonClicked(true);
    if(!(emailArray.indexOf(credentials.email.toLowerCase()) > -1)){
      window.alert("Not An Authorized Email")
      changeButtonClicked(false);
    } else{
      return authManager
      .loginUser(customerCreds)
      .then((parsedResponse) => {
        console.log(parsedResponse)
        if (
          "valid" in parsedResponse &&
          parsedResponse.valid &&
          "token" in parsedResponse
        ) {
          
          if(parsedResponse.verified){
            sessionStorage.setItem("token", parsedResponse.token);
            sessionStorage.setItem("memberId", parsedResponse.memberId)
            setIsLoggedIn(true);

            window.location='/'
          }
          
        } else {
          window.alert("Invalid email or password, please try again.")
          changeButtonClicked(false);
        }
      })
    }
    
  };

  function logout() {
    sessionStorage.clear()
    window.location = '/'
  }

  function buttonOrLoader(){
    if(buttonClicked){
      return <Spin size="small"/>
    } else {
      return <input className="btn" type="button" name="" value="Sign In" onClick={handleLogin}/>
    }
  }

  useEffect(()=>{
    buttonOrLoader();
  }, [buttonClicked])

  return (
<div className="login-box-main login-box">
  <div className="textbox">
    <i className="fa fa-user" aria-hidden="true"></i>
    <input id='email' onChange={handleFieldChange} type="text" placeholder="Email" name="" value={credentials.email}/>
  </div>
  <div className="textbox">
    <i className="fa fa-lock" aria-hidden="true"></i>
    <input id='password' onChange={handleFieldChange} type="password" placeholder="Password" name="" value={credentials.password}/>
  </div>
  {buttonOrLoader()}
</div>
  );
};

export default Login;